export default "__VITE_ASSET__DNU_uz$p__"